import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import _truncate from 'lodash/truncate';

import { textWithMarkdown } from '../../../util/urlMatching';

const linkRenderer = (props) => (
  <a
    href={props.href}
    target="_blank"
    style={{ color: '#6586ff', textDecoration: 'underline' }}
    rel="noreferrer"
  >
    {props.children}
  </a>
);

const paragraphRenderer = (props) => (
  <p className="font-normal text-lg">{props.children}</p>
);

const MdComponents = {
  a: linkRenderer,
  p: paragraphRenderer
};

type AboutProps = {
  description: string;
};

const About: React.FC<AboutProps> = ({ description }) => {
  const [showMore, setShowMore] = useState(false);

  const Description = ({ description }) => {
    const MIN_LENGTH = 500;

    if (description.length <= MIN_LENGTH) {
      return (
        <ReactMarkdown components={MdComponents}>
          {textWithMarkdown(description)}
        </ReactMarkdown>
      );
    }

    if (showMore) {
      return (
        <>
          <ReactMarkdown components={MdComponents}>
            {textWithMarkdown(description)}
          </ReactMarkdown>
          <div
            className="mt-4 text-base font-semibold text-primary-400 cursor-pointer hover:underline"
            onClick={() => {
              setShowMore(false);
            }}
          >
            Show Less
          </div>
        </>
      );
    }

    return (
      <>
        <ReactMarkdown components={MdComponents}>
          {textWithMarkdown(
            _truncate(description, {
              length: MIN_LENGTH
            })
          )}
        </ReactMarkdown>{' '}
        <span
          className="text-base font-semibold text-primary-400 cursor-pointer hover:underline"
          onClick={() => {
            setShowMore(true);
          }}
        >
          Show More
        </span>
      </>
    );
  };

  return (
    <div className="pt-8">
      <h2 className="text-2xl font-semibold">About this event</h2>
      <div className="mt-2 font-normal text-lg leading-relaxed whitespace-pre-wrap">
        <Description description={description} />
      </div>
    </div>
  );
};

export default About;
